import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCalendarCheck, faHourglassHalf } from '@fortawesome/free-solid-svg-icons';
import { ROADMAP_STATUS } from '../../constants';
import { RoadMapData } from '../../constants/roadMap';
import './RoadMap.css';

const RoadMap = () => {
  return (
    <div className='roadMap' id='roadmap'>
      <h1 className='roadMap__title'>The RaceMap</h1>
      <div className='roadMap__box'>
        {RoadMapData.map(roadmap => 
        <div className='roadMap__map'>
          <label className={roadmap.status===ROADMAP_STATUS.DONE? 'roadMap__map__done': roadmap.status===ROADMAP_STATUS.RUNNING? 'roadMap__map__running': 'roadMap__map__working'}>
            <FontAwesomeIcon icon={roadmap.status===ROADMAP_STATUS.DONE? faCheck: roadmap.status===ROADMAP_STATUS.RUNNING? faCalendarCheck: faHourglassHalf}/>
            <label className='roadMap__map__date'>{roadmap.date}</label>
          </label>
          <label className='roadMap__map__name'>{roadmap.name}</label>
          <label>{roadmap.desc}</label>
        </div>
        )}
      </div>
    </div>
  )
}

export default RoadMap;